import React from 'react';
import { motion } from 'framer-motion';
const GOLD = '#d8b878';
const COVER_SRC = 'https://cdn.magicpatterns.com/uploads/nkB7M2PRaWx6YP7bo4V4QA/tapa.png';
export function WhatIsBook() {
  return <section className="relative overflow-hidden bg-matrix-black py-20 md:py-28 px-5 md:px-8" data-id="element-271">
      {/* Subtle digital texture + depth */}
      <div className="pointer-events-none absolute inset-0 z-0 opacity-[0.04]" style={{
      backgroundImage: 'repeating-linear-gradient(90deg, rgba(0,255,65,0.6) 0px, rgba(0,255,65,0.6) 1px, transparent 1px, transparent 10px)',
      maskImage: 'radial-gradient(ellipse at center, black 25%, transparent 80%)',
      WebkitMaskImage: 'radial-gradient(ellipse at center, black 25%, transparent 80%)'
    }} data-id="element-272"></div>
      <div className="pointer-events-none absolute inset-0 z-0 bg-[radial-gradient(ellipse_at_top_left,_rgba(216,184,120,0.06)_0%,_transparent_55%)]" data-id="element-273"></div>
      {/* Soft halo on the cover side + lateral depth so it isn't flat black */}
      <div className="pointer-events-none absolute right-0 top-1/2 z-0 h-[70vh] w-[55vh] -translate-y-1/2 translate-x-1/4 rounded-full bg-[radial-gradient(circle,_rgba(216,184,120,0.10)_0%,_rgba(0,255,65,0.04)_45%,_transparent_72%)] blur-3xl" data-id="element-274"></div>
      <div className="pointer-events-none absolute inset-x-0 top-0 z-0 h-24 bg-gradient-to-b from-matrix-black to-transparent" data-id="element-275"></div>

      <div className="max-w-6xl mx-auto relative z-10 flex flex-col md:flex-row items-center gap-12 md:gap-16" data-id="element-276">
        {/* Left — text */}
        <motion.div initial={{
        opacity: 0,
        x: -40
      }} whileInView={{
        opacity: 1,
        x: 0
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 0.8
      }} className="flex-1 order-2 md:order-1" data-id="element-277">
          <span className="inline-block font-inter text-[10px] md:text-xs tracking-[0.4em] uppercase mb-5" style={{
          color: 'rgba(216,184,120,0.7)'
        }} data-id="element-278">
            El ebook
          </span>
          <h2 className="font-cinzel text-2xl sm:text-3xl md:text-4xl lg:text-5xl text-matrix-cream leading-[1.2] mb-7 md:mb-8 drop-shadow-[0_0_16px_rgba(245,230,200,0.15)]" data-id="element-279">
            ¿Qué es “¿Estás listo para jugar?”
          </h2>

          <div className="space-y-5 text-[15px] md:text-lg text-matrix-white/80 font-light leading-[1.9]" data-id="element-280">
            <p data-id="element-281">
              <span className="italic text-matrix-cream/90" data-id="element-282">
                ¿Estás listo para jugar?
              </span>{' '}
              es más que un ebook de crecimiento personal.
            </p>
            <p data-id="element-283">
              Es una lectura de desprogramación, expansión de conciencia y
              observación interior, diseñada para ayudarte a cuestionar
              creencias profundas, reconocer patrones mentales y emocionales, y
              mirar tu realidad desde una perspectiva más consciente.
            </p>
            <p data-id="element-284">
              A través de una narrativa simbólica, espiritual y provocadora,
              este libro te invita a explorar temas como el ego, el alma, el
              sistema, el miedo, la identidad, la Matrix, las relaciones, la
              realidad simulada y el arte de vivir despierto.
            </p>
          </div>

          {/* Highlighted closing phrase */}
          <div className="mt-9 md:mt-10 border-l-2 pl-5 md:pl-6" style={{
          borderColor: 'rgba(216,184,120,0.6)'
        }} data-id="element-285">
            <p className="font-cinzel italic text-lg sm:text-xl md:text-2xl leading-[1.5] text-matrix-cream" style={{
            textShadow: '0 0 24px rgba(216,184,120,0.25)'
          }} data-id="element-286">
              No busca darte respuestas vacías. Busca ayudarte a hacerte las{' '}
              <span style={{
              color: GOLD
            }} data-id="element-287">
                preguntas correctas.
              </span>
            </p>
          </div>
        </motion.div>

        {/* Right — original cover */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.92
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true,
        margin: '-80px'
      }} transition={{
        duration: 1
      }} className="order-1 md:order-2 flex-shrink-0 flex justify-center" style={{
        perspective: 1000
      }} data-id="element-288">
          <div className="relative" data-id="element-289">
            <div className="absolute -inset-6 rounded-full bg-[radial-gradient(circle,_rgba(216,184,120,0.18)_0%,_rgba(0,255,65,0.08)_45%,_transparent_72%)] blur-2xl" data-id="element-290"></div>
            <motion.img src={COVER_SRC} alt="Ebook: ¿Estás listo para jugar?" className="relative z-10 w-44 sm:w-52 md:w-60 lg:w-72 rounded-xl border border-[rgba(216,184,120,0.3)] shadow-[0_30px_70px_-20px_rgba(0,0,0,0.95),0_0_50px_rgba(216,184,120,0.22)]" animate={{
            y: [0, -10, 0]
          }} transition={{
            duration: 6,
            repeat: Infinity,
            ease: 'easeInOut'
          }} data-id="element-291" />
          </div>
        </motion.div>
      </div>
    </section>;
}